import { render, staticRenderFns } from "./recommend-result-brand.vue?vue&type=template&id=6ab71a7a&scoped=true&"
import script from "./recommend-result-brand.vue?vue&type=script&lang=js&"
export * from "./recommend-result-brand.vue?vue&type=script&lang=js&"
import style0 from "./recommend-result-brand.vue?vue&type=style&index=0&id=6ab71a7a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab71a7a",
  null
  
)

export default component.exports